import { fromJS } from 'immutable';
import * as _ from 'lodash';

import { fetchingState } from '@constants';

import * as actions from '../actions/search';

const initialState = fromJS({
  config: { data: [], state: null },
  codes: { data: {}, state: null },
  stateCds: { data: [], state: null },
  marketAreas: { data: [], state: null },
  resultsConfig: { data: [], state: null },
  results: { data: [], state: null },
  rollCorrections: { data: [], state: null },
  appraisalCompanies: { data: [], state: null },
  reportModifier: {
    data: {},
    state: null,
  },
  taxingUnits: {
    state: null,
    data: {
      taxingUnits: [],
    },
  },
  reportInfo: {
    state: null,
    data: {},
  },
  comments: {
    state: null,
    data: [],
  },
  activeReport: {
    state: null,
    data: {},
  },
  activeReportSubmission: {
    state: null,
    data: {},
  },
  reportSubmissions: {
    state: null,
    data: [],
  },
  activeReportJob: {
    state: null,
    data: {},
  },
  reportJobs: {
    state: null,
    data: [],
  },
  tags: {
    state: null,
    data: [],
  },
  addressFetchData: {
    state: null,
    data: {},
  },
  reportEvents: {
    state: null,
    data: [],
  },
  massCreate: {
    state: null,
    data: {},
  },
  reportDefinitions: {
    state: null,
    data: []
  }
});

const SearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.DELETE_REPORT_SUCCESS: {
      return state.setIn(['results', 'state'], fetchingState.LOADED).setIn(
        ['results', 'data'],
        fromJS(
          state
            .get('results')
            .toJS()
            .data.filter(record => record.reportID !== action.payload),
        ),
      );
    }
    case actions.DELETE_REPORT_START: {
      return state.setIn(['results', 'state'], fetchingState.FETCHING);
    }
    case actions.DELETE_REPORT_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }
    case actions.PROCESS_REPORT_JOB_SUCCESS: {
      const result = action.data;
      return state
        .setIn(['activeReportJob', 'state'], 'loaded')
        .setIn(['activeReportJob', 'data'], fromJS(result));
    }
    case actions.PROCESS_REPORT_JOB_START: {
      return state.setIn(['activeReportJob', 'state'], fetchingState.FETCHING);
    }
    case actions.PROCESS_REPORT_JOB_ERROR: {
      return state.setIn(['activeReportJob', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_ROLL_CORRECTIONS_SUCCESS: {
      const result = action.data;
      return state
        .setIn(['rollCorrections', 'state'], 'loaded')
        .setIn(['rollCorrections', 'data'], fromJS(result));
    }
    case actions.FETCH_ROLL_CORRECTIONS_START: {
      return state.setIn(['rollCorrections', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_ROLL_CORRECTIONS_ERROR: {
      return state.setIn(['rollCorrections', 'state'], fetchingState.ERROR);
    }
    case actions.GET_STATE_CODES_SUCCESS: {
      const result = action.data.results ? action.data.results : [];
      return state
        .setIn(['stateCds', 'state'], 'loaded')
        .setIn(['stateCds', 'data'], fromJS(result));
    }
    case actions.GET_STATE_CODES_START: {
      return state.setIn(['stateCds', 'state'], fetchingState.FETCHING);
    }
    case actions.GET_STATE_CODES_ERROR: {
      return state.setIn(['stateCds', 'state'], fetchingState.ERROR);
    }
    case actions.GET_MARKET_AREAS_SUCCESS: {
      const result = action.data.results ? action.data.results : [];
      return state
        .setIn(['marketAreas', 'state'], 'loaded')
        .setIn(['marketAreas', 'data'], fromJS(result));
    }
    case actions.GET_MARKET_AREAS_START: {
      return state.setIn(['marketAreas', 'state'], fetchingState.FETCHING);
    }
    case actions.GET_MARKET_AREAS_ERROR: {
      return state.setIn(['marketAreas', 'state'], fetchingState.ERROR);
    }
    case actions.GET_REPORT_JOBS_SUCCESS: {
      const result = action.data.jobsummary;
      return state
        .setIn(['reportJobs', 'state'], 'loaded')
        .setIn(['reportJobs', 'data'], fromJS(result));
    }
    case actions.GET_REPORT_JOBS_START: {
      return state.setIn(['reportJobs', 'state'], fetchingState.FETCHING);
    }
    case actions.GET_REPORT_JOBS_ERROR: {
      return state.setIn(['reportJobs', 'state'], fetchingState.ERROR);
    }
    case actions.CREATE_REPORT_SUBMISSION_SUCCESS: {
      const result = action.data.results[0];
      return state
        .setIn(['activeReportSubmission', 'state'], 'loaded')
        .setIn(['activeReportSubmission', 'data'], fromJS(result));
    }
    case actions.CREATE_REPORT_SUBMISSION_START: {
      return state.setIn(
        ['activeReportSubmission', 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.CREATE_REPORT_SUBMISSION_ERROR: {
      return state.setIn(
        ['activeReportSubmission', 'state'],
        fetchingState.ERROR,
      );
    }
    case actions.FINALIZE_REPORT_SUBMISSION_SUCCESS: {
      const result = action.data.results[0];
      return state
        .setIn(['activeReportSubmission', 'state'], 'loaded')
        .setIn(['activeReportSubmission', 'data'], fromJS(result));
    }
    case actions.FINALIZE_REPORT_SUBMISSION_START: {
      return state.setIn(
        ['activeReportSubmission', 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.FINALIZE_REPORT_SUBMISSION_ERROR: {
      return state.setIn(
        ['activeReportSubmission', 'state'],
        fetchingState.ERROR,
      );
    }
    case actions.FETCH_REPORT_SUBMISSIONS_SUCCESS: {
      let result = [];
      if (action.data) {
        result = action.data.results;
      }
      return state
        .setIn(['reportSubmissions', 'state'], 'loaded')
        .setIn(['reportSubmissions', 'data'], fromJS(result));
    }
    case actions.FETCH_REPORT_SUBMISSIONS_START: {
      return state.setIn(
        ['reportSubmissions', 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.FETCH_REPORT_SUBMISSIONS_ERROR: {
      return state.setIn(['reportSubmissions', 'state'], fetchingState.ERROR);
    }
    case actions.UPDATE_REPORT_DEFINITION_SUCCESS: {
      const result = action.data.results[0];
      if (action.payload.update) {
        return state
          .setIn(['results', 'state'], 'loaded')
          .setIn(['activeReport', 'data'], fromJS(result));
      } else {
        return state.setIn(['results', 'state'], 'loaded');
      }
    }
    case actions.UPDATE_REPORT_DEFINITION_START: {
      return state.setIn(['results', 'state'], fetchingState.FETCHING);
    }
    case actions.UPDATE_REPORT_DEFINITION_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_MASS_CREATE_SUCCESS: {
      if (action.data) {
        const result = action.data.results[0];
        return state
          .setIn(['massCreate', 'state'], 'loaded')
          .setIn(['massCreate', 'data'], fromJS(result));
      } else {
        const preResult = {
          createStatus: 'Not Started',
        };
        return state
          .setIn(['massCreate', 'state'], 'loaded')
          .setIn(['massCreate', 'data'], fromJS(preResult));
      }
    }
    case actions.FETCH_MASS_CREATE_START: {
      return state.setIn(['massCreate', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_MASS_CREATE_ERROR: {
      return state.setIn(['massCreate', 'state'], fetchingState.ERROR);
    }
    case actions.CREATE_REPORT_EVENTS_SUCCESS: {
      const result = action.data.results;
      return state
        .setIn(['reportEvents', 'state'], 'loaded')
        .setIn(['reportEvents', 'data'], fromJS(result));
    }
    case actions.CREATE_REPORT_EVENTS_START: {
      return state.setIn(['reportEvents', 'state'], fetchingState.FETCHING);
    }
    case actions.CREATE_REPORT_EVENTS_ERROR: {
      return state.setIn(['reportEvents', 'state'], fetchingState.ERROR);
    }
    case actions.GET_REPORT_INFO_SUCCESS: {
      let formattedData = action.data
        ? action.data.replace(/(\r\n|\n|\r)/gm, ' ')
        : '';
      let rawReportFullQuery = formattedData
        ? formattedData.match(/<queryString(.+)?>\s*.*<\/queryString>/g)
        : null;
      let reportFullQuery = '';
      if (rawReportFullQuery && rawReportFullQuery[0]) {
        reportFullQuery = rawReportFullQuery[0].match(/<!\[CDATA\[.*\]\]/gi);
        if (reportFullQuery[0]) {
          reportFullQuery = reportFullQuery[0]
            .replace('<![CDATA[', '')
            .replace(']]', '');
        } else {
          reportFullQuery = '';
        }
        // .match(/<!\[CDATA\[.*\]\]/gi)[0]
        // .replace('<![CDATA[', '')
        // .replace(']]', '');
      }
      let rawReportFieldNames = action.data.match(/field name="(.*?)"/g);
      let reportFieldNames = [];
      for (let x = 0; x < rawReportFieldNames.length; x++) {
        reportFieldNames.push(
          rawReportFieldNames[x].match(/".*"$/g)[0].replace(/['"]+/g, ''),
        );
      }
      let rawReportFieldTypes = action.data.match(
        /field name="(.*?)" class="(.*?)"/g,
      );
      let reportFieldTypes = [];
      for (let x = 0; x < rawReportFieldTypes.length; x++) {
        rawReportFieldTypes[x] = rawReportFieldTypes[x].match(
          /class="(.*?)"/g,
        )[0];
      }
      for (let x = 0; x < rawReportFieldTypes.length; x++) {
        reportFieldTypes.push(
          rawReportFieldTypes[x].match(/".*"$/g)[0].replace(/['"]+/g, ''),
        );
      }
      let rawReportFieldParams = action.data.match(/parameter name="(.*?)"/g);
      let reportFieldParams = [];
      for (let x = 0; x < rawReportFieldParams.length; x++) {
        reportFieldParams.push(
          rawReportFieldParams[x].match(/".*"$/g)[0].replace(/['"]+/g, ''),
        );
      }
      let rawReportQuery = action.data.match(
        /<!\[CDATA\[select((.|\0|\n|\f|\r|\t|\v)*?)>/gi,
      );
      let reportQuery = null;
      if (rawReportQuery) {
        try {
          reportQuery = rawReportQuery[rawReportQuery.length - 1]
          .match(
            /\..(.*?)[^abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ]/gi,
          )[0]
          .replace('.', '')
          .trim();
        } catch (err) {
          reportQuery = null;
        }
      }
      let reportFieldData = {
        reportFields: [],
        reportParams: [],
        reportView: reportQuery,
        reportFullQuery: reportFullQuery,
      };
      for (let x = 0; x < reportFieldNames.length; x++) {
        reportFieldData.reportFields.push({
          fieldName: reportFieldNames[x],
          fieldType: reportFieldTypes[x],
        });
      }
      for (let x = 0; x < reportFieldParams.length; x++) {
        reportFieldData.reportParams.push({
          paramName: reportFieldParams[x],
        });
      }
      return state
        .setIn(['reportInfo', 'state'], fetchingState.LOADED)
        .setIn(['reportInfo', 'data'], fromJS(reportFieldData));
    }
    case actions.GET_REPORT_INFO_START: {
      return state.setIn(['reportInfo', 'state'], fetchingState.FETCHING);
    }
    case actions.GET_REPORT_INFO_ERROR: {
      return state.setIn(['reportInfo', 'state'], fetchingState.ERROR);
    }
    case actions.GET_PID_ADDRESS_DATA_SUCCESS: {
      return state
        .setIn(['addressFetchData', 'state'], fetchingState.LOADED)
        .setIn(['addressFetchData', 'data'], fromJS(action.data.results));
    }
    case actions.GET_TAXING_UNITS_SUCCESS: {
      return state
        .setIn(['taxingUnits', 'state'], fetchingState.LOADED)
        .setIn(['taxingUnits', 'data'], fromJS(action.data.results));
    }
    case actions.GET_TAGS_SUCCESS: {
      return state
        .setIn(['tags', 'state'], fetchingState.LOADED)
        .setIn(['tags', 'data'], fromJS(action.data.results));
    }
    case actions.POST_TAG_SUCCESS: {
      return state
        .setIn(['tags', 'state'], fetchingState.LOADED)
        .setIn(['tags', 'data'], fromJS(action.data.results));
    }
    case actions.DELETE_TAG_SUCCESS: {
      return state
        .setIn(['tags', 'state'], fetchingState.LOADED)
        .setIn(['tags', 'data'], fromJS(action.data.results));
    }
    case actions.GET_COMMENTS_SUCCESS: {
      return state
        .setIn(['comments', 'state'], fetchingState.LOADED)
        .setIn(['comments', 'data'], fromJS(action.data.results));
    }
    case actions.POST_COMMENT_SUCCESS: {
      let newNotes = state.getIn(['comments', 'data']).toJS();
      newNotes = newNotes.concat(action.data.results);
      return state
        .setIn(['comments', 'state'], fetchingState.LOADED)
        .setIn(['comments', 'data'], fromJS(newNotes));
    }
    case actions.DELETE_COMMENT_SUCCESS: {
      return state.setIn(['comments', 'state'], fetchingState.LOADED).setIn(
        ['comments', 'data'],
        fromJS(
          state
            .get('comments')
            .toJS()
            .data.filter(note => note.commentID !== action.payload),
        ),
      );
    }
    case actions.CREATE_REPORT_DEFINITION_SUCCESS: {
      return state.setIn(['results', 'state'], fetchingState.LOADED);
    }
    case actions.FETCH_REPORT_SUCCESS: {
      const result = action.data.results[0];
      return state
        .setIn(['activeReport', 'state'], fetchingState.LOADED)
        .setIn(['activeReport', 'data'], fromJS(result));
    }
    case actions.FETCH_REPORT_START: {
      return state.setIn(['activeReport', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_REPORT_ERROR: {
      return state.setIn(['activeReport', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_SEARCH_CONFIG_SUCCESS: {
      return state
        .setIn(['config', 'state'], fetchingState.LOADED)
        .setIn(['config', 'data'], fromJS(action.data.results));
    }
    case actions.FETCH_SEARCH_RESULTS_CONFIG_SUCCESS: {
      return state
        .setIn(['resultsConfig', 'state'], fetchingState.LOADED)
        .setIn(['resultsConfig', 'data'], fromJS(action.data.results));
    }
    case actions.SEARCH_SUCCESS: {
      return state
        .setIn(['results', 'state'], fetchingState.LOADED)
        .setIn(['results', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.FETCH_APPRAISAL_COMPANIES_SUCCESS: {
      return state
        .setIn(['appraisalCompanies', 'state'], fetchingState.LOADED)
        .setIn(
          ['appraisalCompanies', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.RESET_ACTIVE_REPORT: {
      return state.setIn(['activeReport', 'data'], fromJS({}));
    }
    case actions.GET_TAXING_UNITS_START: {
      return state.setIn(['taxingUnits', 'state'], fetchingState.FETCHING);
    }
    case actions.GET_TAGS_START: {
      return state.setIn(['tags', 'state'], fetchingState.FETCHING);
    }
    case actions.POST_TAG_START: {
      return state.setIn(['tags', 'state'], fetchingState.FETCHING);
    }
    case actions.GET_COMMENTS_START: {
      return state.setIn(['comments', 'state'], fetchingState.FETCHING);
    }
    case actions.POST_COMMENT_START: {
      return state.setIn(['comments', 'state'], fetchingState.FETCHING);
    }
    case actions.DELETE_COMMENT_START: {
      return state.setIn(['comments', 'state'], fetchingState.FETCHING);
    }
    case actions.CREATE_REPORT_DEFINITION_START: {
      return state.setIn(['results', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_SEARCH_CONFIG_START: {
      return state.setIn(['config', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_SEARCH_RESULTS_CONFIG_START: {
      return state.setIn(['resultsConfig', 'state'], fetchingState.FETCHING);
    }
    case actions.SEARCH_START: {
      return state.setIn(['results', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_APPRAISAL_COMPANIES_START: {
      return state.setIn(
        ['appraisalCompanies', 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.GET_PID_ADDRESS_DATA_ERROR: {
      return state.setIn(['addressFetchData', 'state'], fetchingState.ERROR);
    }
    case actions.GET_TAXING_UNITS_ERROR: {
      return state.setIn(['taxingUnits', 'state'], fetchingState.ERROR);
    }
    case actions.GET_TAGS_ERROR: {
      return state.setIn(['tags', 'state'], fetchingState.ERROR);
    }
    case actions.POST_TAG_ERROR: {
      return state.setIn(['tags', 'state'], fetchingState.ERROR);
    }
    case actions.GET_COMMENTS_ERROR: {
      return state.setIn(['comments', 'state'], fetchingState.ERROR);
    }
    case actions.POST_COMMENT_ERROR: {
      return state.setIn(['comments', 'state'], fetchingState.ERROR);
    }
    case actions.DELETE_COMMENT_ERROR: {
      return state.setIn(['comments', 'state'], fetchingState.ERROR);
    }
    case actions.CREATE_REPORT_DEFINITION_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_SEARCH_CONFIG_ERROR: {
      return state.setIn(['config', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_SEARCH_RESULTS_CONFIG_ERROR: {
      return state.setIn(['resultsConfig', 'state'], fetchingState.ERROR);
    }
    case actions.SEARCH_ERROR: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_APPRAISAL_COMPANIES_ERROR: {
      return state.setIn(['appraisalCompanies', 'state'], fetchingState.ERROR);
    }
    case actions.SET_REPORTMODIFIER: {
      return state.setIn(['reportModifier', 'data'], fromJS(action.windowData));
    }
    case actions.FETCH_REPORT_DEFINITIONS_START: {
      return state.setIn(['reportDefinitions', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_REPORT_DEFINITIONS_ERROR: {
      return state.setIn(['reportDefinitions', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_REPORT_DEFINITIONS_SUCCESS: {
      const result = action.data.results;
      return state
        .setIn(['reportDefinitions', 'state'], 'loaded')
        .setIn(['reportDefinitions', 'data'], fromJS(result));
    }
    default: {
      return state;
    }
  }
};

export default SearchReducer;
